module.exports = __webpack_public_path__ + "static/media/7get.5a777ba5.svg";